// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import { Box, Card, Grid, Typography } from "@mui/material";
import PageLayout from "../../layoutcontainers/PageLayout";
import { useMaterialUIController } from "../../context";
import projectLogo from '../../assest/project_management.png'
import logo from '../../assest/images/logo.png'
import loginImage from '../../assest/images/Login_Image.jpg'

function SigninLayout({ header, title, description, illustration, children }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <PageLayout background="white" height='100%' showNavbar disableFooter>
      <Grid container direction='row' spacing={1}>
        <Grid size={{ xs: 12, sm: 6 }} sx={{
          padding: 1, display: {
            xs: "none",
            sm: "flex", 
          }
        }}>
          <Box
            sx={{
              borderRadius: '15px',
              display: 'flex',
              width: '100%',
              height: '97vh',
            }}
          >
            <img
              src={loginImage}
              alt="Image not loaded"
              style={{
                width: '100%',
                height: '99%',
                justifyContent: "center",
                textAlign: "center",
                alignItems: "center",
                borderRadius: '15px'
              }}
            />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Box>{children}</Box>
        </Grid>
      </Grid>

    </PageLayout>
  );
}

// Typechecking props for the SigninLayout
SigninLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.string,
};

export default SigninLayout;